import { API_ROUTES } from "../utils/constants"
import apiHelper from "./apiHelper"

const pathBase = API_ROUTES.SETTINGS.PACKAGES.AUDIO_BOT

export function createBotPackage(data) {
    return apiHelper({ method: "post", path: pathBase.CREATE, data })
}

export function editBotPackage(data) {
    return apiHelper({ method: "post", path: pathBase.EDIT, data })
}

export function deleteBotPackage(packageId) {
    return apiHelper({ method: "delete", path: pathBase.DELETE, data: { packageId } })
}

export function getBotPackageList() {
    return apiHelper({ method: "get", path: pathBase.GET_ALL })
}
